let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3K1kD")).then(() => parcelRequire('9EcbH'));